import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, Query } from '@angular/fire/firestore';
import { switchMap, take } from 'rxjs/operators';
import * as firebase from 'firebase';
import { Cognitive, SurveyQuestion } from '@app/interface/survey';
import { FirebaseAuthService } from './firebaseauth.service';
import { UserDetail } from '@app/interface/auth.user';
import { StudiesService } from './studies.service';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CognitiveTestService {
  constructor(
    private store: AngularFirestore,
    private afAuth: AngularFireAuth,
    private authService: FirebaseAuthService,
    private studiesService: StudiesService
  ) {}

  public addCognitive(cognitive: Cognitive, studyDetail: any, cognitiveType: string) {
    return this.authService.getUser().pipe(
      switchMap((user: UserDetail) => {
        cognitive.uuid = this.store.createId();
        cognitive.cognitiveTestType = cognitiveType;
        cognitive.createdBy = user.role;
        cognitive.createdByuserId = user.uuid;
        cognitive.studyName = studyDetail.studyName;
        cognitive.studyRef = studyDetail.docRef;
        cognitive.studyId = studyDetail.uuid;
        cognitive.createdAt = firebase.default.firestore.Timestamp.now();
        cognitive.isDelete = false;
        return this.store.collection<Cognitive>('cognitives').doc(cognitive.uuid).set(cognitive, { merge: true });
      })
    );
  }

  public getSurveys(studyName: string) {
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        return this.store
          .collection<Cognitive>('cognitives', (ref) => {
            let query: Query = ref;
            return query.where('studyName', '==', studyName).orderBy('createdAt', 'desc');
          })
          .valueChanges();
      })
    );
  }

  public getCognitivesByStudyId() {
    let studyId = this.studiesService.getStudyId();
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user && studyId) {
          return this.store
            .collection<Cognitive>('cognitives', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId).where('isDelete', '==', false).orderBy('createdAt', 'desc');
            })
            .valueChanges();
        } else {
          return of([]);
        }
      })
    );
  }

  public updateCognitive(cognitive: Cognitive) {
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        cognitive.updatedAt = firebase.default.firestore.Timestamp.now();
        return this.store.collection<Cognitive>('cognitives').doc(cognitive.uuid).update(cognitive);
      })
    );
  }

  public getCognitiveTestsByStudyId() {
    let studyId = this.studiesService.getStudyId();
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user && studyId) {
          return this.store
            .collection<Cognitive>('cognitives', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId).where('isDelete', '==', false).orderBy('createdAt', 'desc');
            })
            .valueChanges();
        } else {
          return of([]);
        }
      })
    );
  }
}
